<template>
  <div class="pt-2 h-full flex flex-col">
    <!-- Floating Action Bar for bulk actions -->
    <FloatingActionBar
      :selected="selectedRoles"
      :total-items="totalRoles"
      :showDeleteSelected="true"
      :show-assign="false"
      :showDeleteAll="false"
      :showUpdateStatus="false"
      :showSelectAll="false"
      @delete-selected="handleShowDialogDelete"
    />
    <!-- <div
      class="justify-end items-center ml-auto"
      :class="[$vuetify.breakpoint.lgAndUp ? 'flex mb-4' : 'flex flex-col']"
    >
      <v-col
        :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
        :class="[$vuetify.breakpoint.lgAndUp ? 'py-0 pr-0' : 'ml-auto mt-2 p-0']"
      >
        <v-text-field
          outlined
          dense
          hide-details
          placeholder="Search Role"
          v-model="filterRole"
          @input="handleInput"
          clearable
        ></v-text-field>
      </v-col>
    </div> -->
    <v-dialog
      v-model="showForm"
      max-width="75%"
      max-height="90vh"
      class="px-2"
      content-class="dialog-content"
      persistent
    >
      <v-card class="d-flex flex-column">
        <ActitiveTabcomponent
          :tabs="mainTabs"
          :defaultTab="'lender'"
          class="flex-grow-1 d-flex flex-column"
        >
          <template #tab-buttons>
            <v-btn icon @click="closeForm">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <template #lender>
            <div class="d-flex flex-column form-content">
              <!-- Tooltip/Help Text -->
              <div class="help-text text-start mx-4 my-2">
                <strong>Role:</strong> Defines what this user can access and do in the system.
                <br />
                <strong>Examples:</strong> ADMIN, HR_MANAGER, EMPLOYEE, TEAM_LEAD
                <br />
                <em>Note: This controls system permissions and features available to the user.</em>
              </div>
              <v-card-title class="flex-shrink-0 bg-white dark-bg-custom shadow-sm">
                <div class="flex flex-col w-full">
                  <v-text-field
                    autofocus
                    v-model="roleName"
                    label="Role Name"
                    hide-details
                    :error-messages="roleNameValidationRule"
                    ref="roleNameField"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-card-title>
              <v-card-text class="mt-2 flex-grow-1 px-0">
                <v-expansion-panels v-model="panel" flat outlined accordion>
                  <v-expansion-panel class="my-3 border border-gray-300">
                    <v-expansion-panel-header class="py-0">
                      <h3 class="font-medium text-lg text-black dark-text-color">Privilege</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="flex justify-end mb-2">
                        <v-btn
                          :color="$vuetify.theme.currentTheme.primary"
                          class="white--text"
                          @click="toggleAllPrivilegePermissions"
                          small
                        >
                          {{ allPrivilegePermissionsText }}
                        </v-btn>
                      </div>
                      <v-row>
                        <v-col cols="6">
                          <v-checkbox
                            :color="$vuetify.theme.currentTheme.primary"
                            @click="checkFormChanges"
                            v-for="(permission, index) in additionalPermissions.slice(
                              0,
                              Math.ceil(additionalPermissions.length / 2)
                            )"
                            :key="index"
                            v-model="permission.checked"
                            :label="permission.value"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                          <v-checkbox
                            :color="$vuetify.theme.currentTheme.primary"
                            @click="checkFormChanges"
                            v-for="(permission, index) in additionalPermissions.slice(
                              Math.ceil(additionalPermissions.length / 2)
                            )"
                            :key="index + Math.ceil(additionalPermissions.length / 2)"
                            v-model="permission.checked"
                            :label="permission.value"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel class="mb-3 border border-gray-300">
                    <v-expansion-panel-header class="py-0">
                      <h3 class="font-medium text-lg text-black dark-text-color">Permissions</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="flex justify-end mb-2">
                        <v-btn
                          :color="$vuetify.theme.currentTheme.primary"
                          class="white--text"
                          @click="toggleAllPermissions"
                        >
                          {{ allPermissionsText }}
                        </v-btn>
                      </div>
                      <div
                        class="mb-2 text-red-600"
                        :class="{
                          'opacity-0': !isFormSubmitted || areAnyPermissionsSelected
                        }"
                      >
                        Please select at least one permission.
                      </div>
                      <v-data-table
                        :headers="permissionHeaders"
                        :items="filteredPermissions"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item="{ item }">
                          <tr>
                            <td class="px-4">{{ item.name }}</td>
                            <td class="px-4">
                              <v-checkbox
                                v-model="item.read"
                                :color="$vuetify.theme.currentTheme.primary"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                :color="$vuetify.theme.currentTheme.primary"
                                v-model="item.write"
                                :disabled="checkIsReadChecked(item)"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                :color="$vuetify.theme.currentTheme.primary"
                                v-model="item.edit"
                                :disabled="checkIsReadChecked(item)"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-checkbox
                                :color="$vuetify.theme.currentTheme.primary"
                                v-model="item.delete"
                                :disabled="checkIsReadChecked(item)"
                              ></v-checkbox>
                            </td>
                            <td class="px-4">
                              <v-chip
                                @click="toggleSelectAllPermissions(item)"
                                class="w-full text-center"
                              >
                                {{ isAllPermissionsSelected(item) ? 'Unselect All' : 'Select All' }}
                              </v-chip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </div>
          </template>
        </ActitiveTabcomponent>
        <div class="border-t px-3 py-3 bg-white">
          <div class="flex justify-end gap-x-4">
            <v-btn outlined @click="closeForm" class="normal-case">Cancel</v-btn>
            <v-btn
              v-if="!isEditingRole"
              :color="$vuetify.theme.currentTheme.primary"
              class="normal-case white--text"
              @click="saveNewRole"
            >
              <v-icon left>mdi-content-save</v-icon>
              Save</v-btn
            >
            <v-btn
              v-if="isEditingRole"
              :color="$vuetify.theme.currentTheme.primary"
              class="normal-case mr-5 white--text"
              @click="updateRole"
              :disabled="isUpdateButtonDisabled"
              >Update</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>
    <AlertPopUp
      :showConfirmationDialog="showDeleteDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="`Do you want to delete selected roles?`"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="deleteSelectedRoles"
      :cancel="handleShowDialogDelete"
      :loading="loading"
    />
    <PrevilageTable
      @edit-role="editRole"
      @role-deleted="handleRoleDeleted"
      @update:options="handleTableOptionsUpdate"
      ref="previlageTable"
      :roles="roles"
      :loadTable="loadTable"
      :totalRoles="totalRoles"
      v-model="selectedRoles"
    />
  </div>
</template>

<script>
import { hasPermission, isModuleVisible, debounce } from '@/utils/common'
import permissionData from '@/utils/permissions'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import PrevilageTable from './PrevilageTable.vue'
import {
  selectAtLeastOne,
  roleCreationSuccess,
  roleCreationError,
  roleDeleteSuccess,
  roleDeleteError,
  roleUpdateSuccess,
  roleUpdateError
} from '@/utils/toastMessages'
import { axiosUrl } from '@/utils/workforceApi'
import FloatingActionBar from '@/components/Workforce/CollectionManagement/CaseModules/FloatingActionBar.vue'
import AlertPopUp from '@/components/AlertPopUp.vue'
export default {
  layout: 'Workforce/default',
  name: 'RolesComponent',
  components: {
    ActitiveTabcomponent,
    PrevilageTable,
    FloatingActionBar,
    AlertPopUp
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      options: { sortBy: [], sortDesc: [], itemsPerPage: 10, page: 1 },
      totalRoles: 0,
      roles: [],
      // useCases: [],
      filterRole: '',
      panel: 0,
      roleName: '',
      showForm: false,
      loadTable: true,
      roleToDeleteId: null,
      roleToEditId: null,
      isEditingRole: false,
      isFormSubmitted: false,
      originalRoleData: null,
      isUpdateButtonDisabled: true,
      permissionHeaders: [
        { text: 'Permission Name', value: 'name' },
        { text: 'View', value: 'read', sortable: false, width: '12%' },
        { text: 'Create', value: 'write', sortable: false, width: '12%' },
        { text: 'Edit', value: 'edit', sortable: false, width: '12%' },
        { text: 'Delete', value: 'delete', sortable: false, width: '12%' },
        { text: 'Action', value: 'action', sortable: false, width: '15%' }
      ],
      permissions: [],
      additionalPermissions: [],
      selectedRoles: [],
      showDeleteDialog: false,
      loading: false
    }
  },

  watch: {
    options: {
      handler() {
        this.fetchRoles()
      },
      deep: true,
      immediate: false
    },
    roleName() {
      this.checkFormChanges()
    },
    permissions: {
      handler() {
        this.checkFormChanges()
      },
      deep: true
    }
  },
  async mounted() {
    await this.populatePermissions()
    // Fetch roles on component mount
    await this.fetchRoles()
  },
  methods: {
    resetForm() {
      this.roleName = ''
      this.permissions.forEach((permission) => {
        permission.read = false
        permission.write = false
        permission.edit = false
        permission.delete = false
      })
      this.additionalPermissions.forEach((permission) => {
        permission.checked = false
      })
    },

    isRoleModuleShouldVisible(module) {
      return isModuleVisible(module)
    },

    openForm() {
      this.isFormSubmitted = false
      this.isEditingRole = false
      this.resetForm()
      this.showForm = true
    },
    async populatePermissions() {
      try {
        const response = await this.$axios.get(axiosUrl.role.populatePermissions)

        // await this.getConfig()
        const availableModules = response.data.modules

        this.additionalPermissions = response.data.privileges

        // if (!this.useCases?.includes('inventory')) {
        //   delete availableModules.INVENTORY_MANAGEMENT
        //   delete availableModules.INVENTORY_REQUEST
        // }
        console.log(availableModules, 'aaaa')
        this.permissions = Object.keys(availableModules).map((moduleName) => {
          return {
            key: moduleName,
            name: availableModules[moduleName],
            read: false,
            write: false,
            edit: false,
            delete: false,
            visibility: this.isRoleModuleShouldVisible(moduleName)
          }
        })
      } catch (error) {
        console.error('Error fetching available modules:', error)
      }
    },
    handleInput: debounce(async function () {
      this.options.page = 1
      await this.fetchRoles()
    }, 500),
    async fetchRoles() {
      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        const params = {
          page: page,
          limit: itemsPerPage > -1 ? itemsPerPage : this.totalTasks
        }

        if (sortBy.length > 0) {
          params.sortBy = sortBy[0]
        }
        if (sortDesc.length > 0) {
          params.sortOrder = sortDesc[0] ? 'desc' : 'asc'
        }
        if (this.filterRole) [(params.search = this.filterRole)]

        this.loadTable = true
        const response = await this.$axios.get(axiosUrl.role.getRoles, {
          params: params
        })

        if (response.data.success) {
          this.roles = response.data.roles
          this.loadTable = false

          this.totalRoles = response.data.pagination?.totalCount || this.roles.length
        } else {
          console.error('Error fetching roles:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching roles:', error)
        this.loadTable = false
      }
    },
    handleTableOptionsUpdate(newOptions) {
      // Update the options and trigger fetchRoles
      this.options = { ...this.options, ...newOptions }
    },

    async saveNewRole() {
      try {
        this.isFormSubmitted = true

        const isValid = !!this.roleName

        if (!isValid) {
          return
        }

        const isAnyPermissionSelected = this.permissions.some((permission) => {
          return permission.read || permission.write || permission.edit || permission.delete
        })

        if (!isAnyPermissionSelected) {
          this.$toast.error(selectAtLeastOne)
          return
        }

        const selectedPrivilege = []

        this.additionalPermissions.forEach((permission) => {
          if (permission.checked) {
            selectedPrivilege.push(`${permission.key}`)
          }
        })
        const selectedPermissions = []

        this.permissions.forEach((permission) => {
          if (permission.read) {
            selectedPermissions.push(`${permission.key}:read`)
          }
          if (permission.write) {
            selectedPermissions.push(`${permission.key}:write`)
          }
          if (permission.edit) {
            selectedPermissions.push(`${permission.key}:edit`)
          }
          if (permission.delete) {
            selectedPermissions.push(`${permission.key}:delete`)
          }
        })

        const requestBody = {
          role: this.roleName,
          permissions: selectedPermissions,
          extraPrivileges: selectedPrivilege
        }

        const response = await this.$axios.post(axiosUrl.role.postRoles, requestBody)

        if (response.data.success) {
          // Add the new role to the list
          this.roles.push(response.data.role)
          this.totalRoles += 1
          this.$toast.success(roleCreationSuccess)
          this.resetForm()
          this.showForm = false
        } else {
          this.$toast.error(roleCreationError)
          console.error(roleCreationError, response.data.message)
        }
      } catch (error) {
        this.$toast.error(roleCreationError)
        console.error(roleCreationError, error)
      }
    },

    async editRole(roleData) {
      this.originalRoleData = { ...roleData }

      this.roleName = roleData.role

      this.permissions.forEach((permission) => {
        permission.read = roleData?.permissions?.includes(`${permission.key}:read`)
        permission.write = roleData?.permissions?.includes(`${permission.key}:write`)
        permission.edit = roleData?.permissions?.includes(`${permission.key}:edit`)
        permission.delete = roleData?.permissions?.includes(`${permission.key}:delete`)
      })
      this.additionalPermissions.forEach((permission) => {
        permission.checked = roleData?.extraPrivileges?.includes(permission.key)
      })

      this.isUpdateButtonDisabled = true

      this.isEditingRole = true
      this.roleToEditId = roleData._id

      this.showForm = true
    },

    checkFormChanges() {
      // Compare the form data with the original roleData
      if (this.originalRoleData) {
        const isRoleNameChanged = this.roleName.trim() !== this.originalRoleData.role

        const isPermissionsChanged = this.permissions.some((permission) => {
          return (
            permission.read !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:read`) ||
            permission.write !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:write`) ||
            permission.edit !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:edit`) ||
            permission.delete !==
              this.originalRoleData?.permissions?.includes(`${permission.key}:delete`)
          )
        })

        const originalKeys = this.originalRoleData.extraPrivileges.sort() // Sort for consistent comparison
        const currentKeys = this.additionalPermissions
          .filter((permission) => permission.checked)
          .map((permission) => permission.key)
          .sort()

        const isAdditionalPermissionsChanged =
          JSON.stringify(originalKeys) !== JSON.stringify(currentKeys)

        this.isUpdateButtonDisabled = !(
          isRoleNameChanged ||
          isPermissionsChanged ||
          isAdditionalPermissionsChanged
        )
      }
    },
    async updateRole() {
      try {
        this.isFormSubmitted = true

        const isValid = !!this.roleName

        if (!isValid) {
          return
        }

        const isAnyPermissionSelected = this.permissions.some((permission) => {
          return permission.read || permission.write || permission.edit || permission.delete
        })

        if (!isAnyPermissionSelected) {
          this.$toast.error(selectAtLeastOne)
          return
        }
        const selectedPrivilege = []

        this.additionalPermissions.forEach((permission) => {
          if (permission.checked) {
            selectedPrivilege.push(`${permission.key}`)
          }
        })

        const selectedPermissions = []

        this.permissions.forEach((permission) => {
          if (permission.read) {
            selectedPermissions.push(`${permission.key}:read`)
          }
          if (permission.write) {
            selectedPermissions.push(`${permission.key}:write`)
          }
          if (permission.edit) {
            selectedPermissions.push(`${permission.key}:edit`)
          }
          if (permission.delete) {
            selectedPermissions.push(`${permission.key}:delete`)
          }
        })

        const requestBody = {
          role: this.roleName,
          permissions: selectedPermissions,
          extraPrivileges: selectedPrivilege
        }

        const response = await this.$axios.put(
          `${axiosUrl.role.putRoles}/${this.roleToEditId}`,
          requestBody
        )

        if (response.data.success) {
          const updatedRoleIndex = this.roles.findIndex((role) => role._id === this.roleToEditId)
          if (updatedRoleIndex !== -1) {
            // Replace the updated role in the list
            this.roles.splice(updatedRoleIndex, 1, response.data.role)
          }
          this.$toast.success(roleUpdateSuccess)
          this.resetForm()
          this.isEditingRole = false

          this.showForm = false
        } else {
          this.$toast.error(roleUpdateError)
          console.error(roleUpdateError, response.data.message)
        }
      } catch (error) {
        this.$toast.error(roleUpdateError)
        console.error(roleUpdateError, error)
      }
    },

    closeForm() {
      this.isFormSubmitted = false
      this.showForm = false
      this.resetForm()
    },
    checkIsReadChecked(item) {
      if (!item.read) {
        item.write = false
        item.edit = false
        item.delete = false
      }
      return !item.read
    },
    toggleAllPermissions() {
      if (this.areAllPermissionsSelected()) {
        this.permissions.forEach((permission) => {
          permission.read = false
          permission.write = false
          permission.edit = false
          permission.delete = false
        })
      } else {
        this.permissions.forEach((permission) => {
          permission.read = true
          permission.write = true
          permission.edit = true
          permission.delete = true
        })
      }
    },
    toggleAllPrivilegePermissions() {
      if (this.allPrivilegePermissionsText == 'Deselect All') {
        this.additionalPermissions = this.additionalPermissions.map((permission) => {
          return {
            ...permission,
            checked: false
          }
        })
      } else {
        this.additionalPermissions = this.additionalPermissions.map((permission) => {
          return {
            ...permission,
            checked: true
          }
        })
      }
    },
    areAllPermissionsSelected() {
      return this.permissions.every((permission) => {
        return permission.read && permission.write && permission.edit && permission.delete
      })
    },
    toggleSelectAllPermissions(item) {
      const isSelected = this.isAllPermissionsSelected(item)

      if (isSelected) {
        this.deselectAllPermissions(item)
      } else {
        this.selectAllPermissions(item)
      }
    },

    selectAllPermissions(item) {
      item.read = true
      item.write = true
      item.edit = true
      item.delete = true
    },

    deselectAllPermissions(item) {
      item.read = false
      item.write = false
      item.edit = false
      item.delete = false
    },
    isAllPermissionsSelected(item) {
      return item.read && item.write && item.edit && item.delete
    },
    // async getConfig() {
    //   try {
    //     const response = await this.$axios.get('/org/config')

    //     const data = response.data?.config
    //     this.useCases = data.enabledUseCases

    //     return data || {}
    //   } catch (error) {
    //     console.error('Error fetching config:', error)
    //   }
    // },

    // Method to be called from parent component (OrganizationHierarchy.vue)
    addRole() {
      this.openForm()
    },
    handleRoleDeleted(roleId) {
      // Remove the deleted role from the list
      const roleIndex = this.roles.findIndex((role) => role._id === roleId)
      if (roleIndex !== -1) {
        this.roles.splice(roleIndex, 1)
        this.totalRoles -= 1
      }
      // Refresh the roles list
      this.fetchRoles()
    },
    handleShowDialogDelete() {
      this.showDeleteDialog = !this.showDeleteDialog
      if (this.showDeleteDialog === false) {
        this.fetchRoles()
      }
    },
    async deleteSelectedRoles() {
      this.loading = true

      const promises = []

      // Make API calls and store promises in the array
      this.selectedRoles?.forEach(async (item) => {
        promises.push(this.deleteSingleRole(item._id))
      })

      // Wait for all API calls to complete
      try {
        const results = await Promise.all(promises)

        if (!results.includes(undefined)) {
          this.$toast.success('Roles deleted successfully.')
        }
        this.loading = false
        this.selectedRoles = []
        this.handleShowDialogDelete(false)
      } catch (error) {
        this.$toast.error('An error occurred while deleting the roles.')
        console.error(error)
      }
    },
    async deleteSingleRole(roleId) {
      try {
        let response = await this.$axios.delete(`${axiosUrl.role.deleteRoles}/${roleId}`)
        return response.data
      } catch (error) {
        console.error(error)
      }
    }
  },
  computed: {
    mainTabs() {
      const tabs = [
        {
          label: this.isEditingRole ? 'Edit Role' : 'Add Role',
          key: 'lender',
          icon: this.isEditingRole ? 'mdi-pencil' : 'mdi-plus',
          component: 'Roles'
        }
      ]
      return tabs
    },
    allPrivilegePermissionsText() {
      const allChecked = this.additionalPermissions.every((permission) => permission.checked)
      return allChecked ? 'Deselect All' : 'Select All'
    },
    areAnyPermissionsSelected() {
      return this.permissions.some((permission) => {
        return permission.read || permission.write || permission.edit || permission.delete
      })
    },
    allPermissionsText() {
      return this.areAllPermissionsSelected() ? 'Unselect All' : 'Select All'
    },
    canAdd() {
      return hasPermission(this.userData, permissionData.settingWrite)
    },
    roleNameValidationRule() {
      return !this.roleName && this.isFormSubmitted ? ['Required.'] : []
    },
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.visibility)
    }
  }
}
</script>

<style scoped>
.permission-fade-enter-active,
.permission-fade-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.permission-fade-enter,
.permission-fade-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.opacity-0 {
  transition: opacity 0.3s;
  opacity: 0;
  margin-bottom: 0;
}

.appear-delay {
  transition: opacity 0.3s ease-in-out 0.1s;
}
.table-header {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.bord {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

.v-input--is-disabled .v-input__control {
  opacity: 0.5;
}
.form-content {
  padding: 12px;
  max-height: 70vh;
  overflow-y: auto;
}
</style>
